<template>
	<textarea
		ref="input"
		:value="value"
		@input="onUpdate($event.target.value)"
		@keydown="onKeydown"
		rows="1"
		class="chat-input-message"
		placeholder="Введите текст сообщения"
		autocomplete="off"></textarea>
</template>

<script>
import eventBus from '../eventbus';

export default {
	props: {
		value: String,
		// autocompletion: non-managed-object,
	},

	data(){
		return {
			tester: null,
			state: eventBus.state,
		};
	},

	methods: {
		onUpdate(val){
			this.$emit('input', val);
		},

		onKeydown(e){
			if (this.autocompletion._keydown(e)){
				if (e.keyCode == 13){
					if (e.shiftKey){
						return;
					} else {
						this.$emit('send');
					}

					e.preventDefault();
				}
				else if (e.keyCode == 9){
					e.preventDefault();
				}
			} else {
				this.onUpdate(this.$refs.input.value);
			}
		},

		reCalcHeight(){
			let tester = this.tester;
			let el = this.$refs.input;

			tester.style.width = `${el.clientWidth}px`;
			tester.value = el.value;
			let nh = tester.scrollHeight;

			if (nh > 150){
				nh = 150;
			}

			if (nh != el.clientHeight){
				el.style.height = `${nh}px`;
				this.$emit('resize');
			}
		},

		paste(text){
			let ipt = this.$refs.input;

			ipt.focus();
			ipt.setRangeText(text);
			ipt.selectionStart += text.length;

			this.$emit('input', ipt.value);
		},

		getInputElement(){
			return this.$refs.input;
		},
	},

	watch: {
		value(o, n){
			setTimeout(this.reCalcHeight.bind(this), 0);
		},
	},

	created(){
		let styles = {
			display: 'inline-block',
			height: 'auto',
			'box-sizing': 'border-box',
			border: 'none',
			margin: '0',
			padding: '15px',
			background: 'none',
			'overflow': 'hidden',
			outline: 'none',
			resize: 'none',
			position: 'absolute',
			bottom: '0',
			visibility: 'hidden',
		};

		let el = document.createElement('textarea');
		el.setAttribute('rows', 1);
		el.tabIndex = -1;
		for (let key in styles){
			el.style[key] = styles[key];
		}
		document.body.appendChild(el);

		this.tester = el;

		// TODO: $off some days
		eventBus.$on('setFocusToMessageInput', () => {
			this.$refs.input.focus();
		});
	},

	beforeDestroy(){
		this.tester.remove();
	},
}
</script>

<style lang="less" scoped>
textarea.chat-input-message {
	box-sizing: border-box;
	border: none;
	margin: 0;
	padding: 15px;
	background: none;
	overflow-x: hidden;
	overflow-y: auto;
	outline: none;
	resize: none;
}
</style>
